module.exports = Wix;